var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1527.5 -1063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.794,0A2.794,2.794,0,1,1,0,2.794,2.794,2.794,0,0,1,2.794,0Z",
    transform: "translate(1540.706 1074.995)",
    fill: "#1b428a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1528.5 1064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.753,1.713A15,15,0,1,0,16.137,31c.436,0,.877-.019,1.32-.057A15.018,15.018,0,0,0,31.1,14.693a1.226,1.226,0,0,0-2.443.214A12.553,12.553,0,1,1,20,4.053a1.23,1.23,0,1,0,.755-2.34Z",
    transform: "translate(-1.16 -0.998)",
    fill: "#1b428a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.694,42.966a1.222,1.222,0,0,0,0,1.429c.165.238,4.1,5.638,9.2,5.638s9.033-5.4,9.2-5.638a1.222,1.222,0,0,0,0-1.429c-.165-.238-4.1-5.636-9.2-5.636S24.859,42.728,24.694,42.966Zm15.827.714a16.029,16.029,0,0,1-1.669,1.667,8.184,8.184,0,0,1-4.958,2.231,8.138,8.138,0,0,1-4.96-2.231,16.027,16.027,0,0,1-1.669-1.667,16.027,16.027,0,0,1,1.669-1.667,8.184,8.184,0,0,1,4.958-2.231,8.145,8.145,0,0,1,4.958,2.231,16.029,16.029,0,0,1,1.669,1.667Z",
    transform: "translate(-18.915 -28.68)",
    fill: "#1b428a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.c2ee74ad134d04d1484f6b8209b709f8.svg";
export { ForwardRef as ReactComponent };